module.exports = __webpack_public_path__ + "static/media/dataTable_icon.9466e2e6.svg";